"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgMobile = exports.SvgDesktop = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
  ${props => (0, _layout.setContainer)({
  size: props.useContainer ? 'lg' : 'xl'
})}
`;
exports.Container = Container;
const Svg = _styledComponents.default.img`
  width: 100%;
  max-width: 100%;
`;
const SvgMobile = (0, _styledComponents.default)(Svg)`
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    display: none;
  }
`;
exports.SvgMobile = SvgMobile;
const SvgDesktop = (0, _styledComponents.default)(Svg)`
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    display: none;
  }
`;
exports.SvgDesktop = SvgDesktop;
//# sourceMappingURL=styles.js.map